const SET_CONTROLS = (state, payload) => {
    state.controls = [];
    state.controls = payload;
}
const CLEAR_CONTROLS = (state) => {
    state.controls = [];
    state.controls = '';
}

const SET_CONTROL = (state, payload) => {
    state.control = [];
    state.control = payload;
}
const CLEAR_CONTROL = (state) => {
    state.control = [];
    state.control = '';
}

const SET_CONTROLLER_STATUS = (state, payload) => {
    state.controller_status = '';
    state.controller_status = payload;
}

const CLEAR_CONTROLLER_STATUS = (state) => {
    state.controller_status = [];
}

export {
    SET_CONTROLS,
    CLEAR_CONTROLS,
    SET_CONTROL,
    CLEAR_CONTROL,
    SET_CONTROLLER_STATUS,
    CLEAR_CONTROLLER_STATUS
}
